import getUrls from "../../api/index.js";
import { IConclusionService } from "./ITypes.ts";
import ConclusionServiceWebLauncher from "./conclusion-service-weblauncher.ts";
import ConclusionService from "./conclusion-service.ts";

const prepareConclusionService = (basepath, standAloneMode) => {
    let conclusionService: IConclusionService | undefined = undefined;
    if (standAloneMode) {
        const { originPath } = getUrls(basepath);
        conclusionService = new ConclusionService(originPath);
    } else conclusionService = new ConclusionServiceWebLauncher();
    return conclusionService;
};

export default prepareConclusionService;
